"use strict";exports.__esModule=true;exports.default=void 0;var constant=function constant(x){return function(){return x}};var _default=constant;exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/utils/src/scale-utils/constant.js
// module id = fIjR
// module chunks = 5